const yearPattern = /^(19|20)\d{2}(?:[-/](19|20)?\d{2})?$/;
const enginePattern = /^(\d(?:\.\d+)?(?:[lL])?|[1-9]\d{2,4}cc)$/i;

export function parseFitment(fitment) {
  const normalizedFitment = String(fitment ?? "").trim() || "General fitment";
  const tokens = normalizedFitment.split(/\s+/).filter(Boolean);
  const [make = "General", ...rest] = tokens;
  const yearTokenIndex = rest.findIndex((token) => yearPattern.test(token));
  const engineTokenIndex = rest.findIndex((token) => enginePattern.test(token));
  const yearToken = yearTokenIndex >= 0 ? rest[yearTokenIndex] : "";
  const engineToken = engineTokenIndex >= 0 ? rest[engineTokenIndex] : "";
  const modelTokens = rest.filter((_, index) => index !== yearTokenIndex && index !== engineTokenIndex);

  return {
    make,
    model: modelTokens.join(" ") || normalizedFitment,
    year_from: yearToken ? Number(yearToken.slice(0, 4)) : null,
    year_to: yearToken
      ? Number(yearToken.includes("-") || yearToken.includes("/") ? yearToken.slice(-4) : yearToken.slice(0, 4))
      : null,
    engine: engineToken || "",
    notes: normalizedFitment,
  };
}

export function formatFitmentLabel(product) {
  const parts = [String(product.fitmentMake ?? "").trim(), String(product.fitmentModel ?? "").trim()].filter(Boolean);

  const yearFrom = Number(product.fitmentYearFrom);
  const yearTo = Number(product.fitmentYearTo);
  const hasYearFrom = Number.isInteger(yearFrom) && yearFrom >= 1900;
  const hasYearTo = Number.isInteger(yearTo) && yearTo >= 1900;

  if (hasYearFrom || hasYearTo) {
    const yearLabel =
      hasYearFrom && hasYearTo && yearFrom !== yearTo
        ? `${yearFrom}-${yearTo}`
        : String(hasYearFrom ? yearFrom : yearTo);

    parts.push(yearLabel);
  }

  const engine = String(product.fitmentEngine ?? "").trim();
  if (engine) {
    parts.push(engine);
  }

  return parts.join(" ");
}

export function formatParsedFitmentLabel(fitment) {
  return formatFitmentLabel({
    fitmentMake: fitment.make,
    fitmentModel: fitment.model,
    fitmentYearFrom: fitment.year_from,
    fitmentYearTo: fitment.year_to,
    fitmentEngine: fitment.engine,
  });
}
